<script>
export default {
    props: {
        slice: {
            type: Object,
            required: true
        },
        isFirstSlice: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>